import WebServiceWrapper from "./WebServiceWrapper";

export const HruService = {
  GetAllHRUDetails,
  SaveHRUDetails,
};

function   GetAllHRUDetails(patientId) {
  return WebServiceWrapper.Get(`/hru/GetAllHruData?patientId=${patientId}`);
}

function SaveHRUDetails(payload) {
  return WebServiceWrapper.PostWithHeader("/hru/SaveHruData", payload);
}

